import { api } from "./api";

export const organisationService = {
  // Get all organisations
  getOrganisations: () => api.get("/organisation").then((res) => res.data),

  // Get organisation by ID
  getOrganisation: (id) =>
    api.get(`/organisation/${id}`).then((res) => res.data),

  // Get organisation members
  getOrganisationMembers: (id) =>
    api.get(`/organisation/${id}/members`).then((res) => res.data),

  // Get organisation contacts
  getOrganisationContacts: (id) =>
    api.get(`/organisation/${id}/contacts`).then((res) => res.data),

  // Get organisation geofences
  getOrganisationGeofences: (id) =>
    api.get(`/organisation/${id}/geofences`).then((res) => res.data),

  // Get organisation actions
  getOrganisationActions: (id) =>
    api.get(`/organisation/${id}/actions`).then((res) => res.data),

  // Create organisation
  createOrganisation: (orgData) => api.post("/organisation", orgData),

  // Update organisation
  updateOrganisation: (id, orgData) => api.put(`/organisation/${id}`, orgData),

  // Delete organisation
  deleteOrganisation: (id) => api.delete(`/organisation/${id}`),

  // Delete organisation member
  deleteOrganisationMember: (organisationId, userId) =>
    api.delete(`/organisation/${organisationId}/members/${userId}`),

  // Update organisation members
  updateOrganisationMembers: (organisationId, memberIds) =>
    api.put(`/organisation/${organisationId}/members`, { members: memberIds }),

  // Change organisation owner
  changeOrganisationOwner: (organisationId, ownerId) =>
    api.put(`/organisation/${organisationId}/owner`, { owner_id: ownerId }),

  // Change organisation name
  changeOrganisationName: (organisationId, name) =>
    api.put(`/organisation/${organisationId}/name`, { name }),

  // Get organisation member roles
  getOrganisationRoles: (organisationId) =>
    api.get(`/organisation/${organisationId}/roles`).then((res) => res.data),

  // Update organisation member role
  updateOrganisationMemberRole: (organisationId, userId, roleData) =>
    api.put(`/organisation/${organisationId}/roles/${userId}`, roleData),
};
